module.exports = __webpack_public_path__ + "img/details-product.fb5e9d6.webp";